module.exports = __webpack_public_path__ + "static/media/2_pl.a2fb7516.png";